import { render } from "./IsoVoyageTurkey.vue?vue&type=template&id=ff949bbc"
import script from "./IsoVoyageTurkey.vue?vue&type=script&lang=js"
export * from "./IsoVoyageTurkey.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__